import React from "react";
import "./ServiceScreen.css";
import { Container, Row, Col } from "react-bootstrap";
import Services from "../assets/images/About/Services.jpg";

import Flex from "../assets/images/Services/FlexPrinting.png";
import Offset from "../assets/images/Services/Offset.png";
import Screen from "../assets/images/Services/ScreenPrinting.png";
import Gifts from "../assets/images/Services/CustomizedGifts.png";
import Stickers from "../assets/images/Services/MugPrint.png";
import Boards from "../assets/images/Services/AdvBoards.png";

// Features Data
const features = [
  "We have what you need.",
  "You can customize everything.",
  "We use premium quality Colors/ Inks/ Media.",
  "Our prints and printing materials are durable.",
  "Eye-catching and visually appealing output.",
  "Quick customer service (Same day printing anywhere in Chandigarh).",
];

// Services Data
const services = [
  {
    title: "Flex Printing",
    description: "High-quality flex printing for banners, hoardings, and more.",
    icon: Flex,
  },
  {
    title: "Offset Printing",
    description: "Reliable and efficient offset printing services.",
    icon: Offset,
  },
  {
    title: "Screen Printing",
    description: "Custom screen printing for various applications.",
    icon: Screen,
  },
  {
    title: "Customized Gifts",
    description: "Personalized gift items for special occasions.",
    icon: Gifts,
  },
  {
    title: "Stamps and Stickers",
    description: "Professional stamp and seal making services.",
    icon: Stickers,
  },
  {
    title: "Advertising Boards",
    description: "Creative solutions for advertising and display boards.",
    icon: Boards,
  },
];

function ServiceScreen() {
  return (
    <>
      <div className="main-service-container py-3">
        <h1 className="service-title py-3">Our Services</h1>

        <Row className="align-items-center my-3 no-gutters">
          {/* Left side - Text */}
          <Col
            xs={12}
            md={6}
            className="d-flex flex-column justify-content-center m-0 p-3"
            style={{ backgroundColor: "#f2f2f0", height: "400px" }}
          >
            <div className="text-center">
              <h2 className="fw-bold">Flex and Digital Printing Services</h2>
              <p>
                The features of flex banner printing services making them as
                popular among masses as the best mean of advertising. <br />
                We make flex banners, which are white translucent substrate for
                small and wide format backlit display, visually soft surface and
                excellent printability by minimizing showing through, more clear
                and visible image creation by suitable transmittance. We made
                them in multi-colors with flexible quantity.
              </p>
            </div>
          </Col>

          {/* Right side - Image */}
          <Col xs={12} md={6} className="text-center p-0">
            <img
              src={Services}
              alt="frame pic"
              className="img-fluid w-100"
              style={{ height: "400px", objectFit: "cover" }}
            />
          </Col>
        </Row>

        {/* Features Section */}
        <div className="features-section py-3">
          <h1 className="py-3">Online printing made easy</h1>
          <ul className="features-list ">
            {features.map((feature, index) => (
              <li key={index} className="feature-item">
                <span className="feature-number">{index + 1}</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>

        {/* Other Services Section */}
        <div className="service-container py-0">
          <h1 className="service-title py-3">Other Services</h1>
          <Container>
            <div className="service-cards my-3">
              {services.map((service, index) => (
                <div key={index} className="service-card">
                  <img src={service.icon} className="service-icon" alt="icon" />
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default ServiceScreen;
